<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  
}
</script>

<style>
body,h1,h2,h3,h4,h5,h6,li,ol,span,p,pre,th,ul{margin:0;padding:0;}
html {
  font-size: 10px;
}
body {
  font-size: 16px;
  font-weight: 500;
  background-color: #fff;
}
#app {
  width: 100%;
  text-align: center;
  font-family:PingFangSC-Semibold,PingFang SC;
  /**字体抗锯齿渲染，使用后字体看起来会更清晰舒服 */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
} 
/**一级容器定宽居中 */
#app>.container {
  width: 100%;
  margin: 0 auto;
}
li {
  list-style-type: none;
}
img {
  width: 100%;
  height: 100%;
}
button,input {
  outline: none;
  border: 0;
}
.router_link {
  text-decoration: none;
  color: #000;
}
.router_link:hover {
  color: #a3a3a3;
  cursor: pointer;
}
.router_link:active {
  color: #000;
}
/* 页头 */
.tabs {
  width: 1064px;
  margin: 0 auto;
  margin-top: 24px;
  margin-bottom: 32px;
}
.tabs > div:first-child {
  display: flex;
  justify-content: space-between;
  font-weight: 400;
  font-size: 20px;
  color: #fff;
  line-height: 24px;
}
.tabs > div:first-child > div:hover {
  color: #a3a3a3;
  cursor: pointer;
}
.tabs .is-active {
  font-weight: 600;
  /* font-size: 20px; */
}
.tabs > div:nth-child(2) {
  width: 1200px;
  height: 2px;
  background-color: #000;
  margin-top: 7px;
}
.tabs .tab_bar {
  height: 4px;
  background: #fff;
  margin-top: -3px;
  width: 24px;
  transform: translateX(8px);
}
/* 二级导航栏 */
.header_nav {
  display: flex;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 42px;
}
.header_nav>div {
  width: 144px;
  height: 36px;
  line-height: 36px;
  border:1px solid rgba(0,0,0,1);
}
/* 标题 */
.title {
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 32px;
}
.title>div {
  width: 42px;
  height: 10px;
  background-color: #000;
  opacity:0.12;
  margin: 0 auto;
  margin-top: -10px;
}
.section>div:first-child .title>div {
  width: 24px;
}
/* 简介 */
.intro,.team {
  text-align: left;
  font-size: 14px;
  font-weight:400;
  color:rgba(112,112,112,1);
  line-height:32px;
  margin-bottom: 36px;
  text-indent:28px;
}
/* 理念 */
.culture {
  padding: 0 67px;
}
.culture ul {
  display: flex;
  justify-content: space-between;
}
.icon {
  width:120px;
  height:120px;
  border:1px solid rgba(216,216,216,1);
  border-radius: 50%;
  margin: 0 auto;
}
.icon>span {
  font-weight: 500;
  line-height: 120px;
}
.icon>span:first-child {
  font-size: 24px;
}ss
.icon>span:nth-child(2) {
  font-size: 18px;
}
/* 厂商图片 三张 */
.partner_img {
  display: flex;
  margin-bottom: 42px;
}
.partner_img>div {
  height: 239px;
}
.partner_img>div:first-child {
  width: 365px;
  margin-right: 32px;
}
.partner_img>div:nth-child(2) {
  width: 318px;
  margin-right: 32px;
}
.partner_img>div:nth-child(3) {
  width: 317px;
}
/* 页脚 */
.footer {
  width: 1064px;
  display: flex;
  justify-content: space-between;
  margin: 18px auto 62px auto;
  text-align: left;
}

.footer .line {
  width: 6px;
  height: 18px;
  background-color: #000;
  display: inline-block;
  margin-right: 10px;
  margin-top: 3.5px;
}
.footer>div:first-child {
  width: 307px;
  height: 113px;
}
.footer .footer_title {
  display: flex;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
}
.footer p,.footer a {
  color: #000;
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 10px;
}
.footer a {
  text-decoration: none;
}
.footer a:hover {
  text-decoration-line: underline;
}
.footer .footer_icon {
  width:90px;
  z-index: 1;
  margin-right: 41px;
}
.footer .footer_icon>.qr {
  width:90px;
  height:97px;
  display: none;
  z-index: 1;
}
.footer .footer_icon>div:nth-child(2) {
  width:20px;
  height:20px;
  margin: 0 auto;
  margin-top: 4px;
}
.footer_icon:hover .qr {
  display: block !important;
  z-index: 1;
}
.footer_icon:hover {
  margin-top: -97px !important;
}
#beian {
  text-decoration: underline;
}
</style>
